<nav
    class="navbar navbar-light bg-light fixed-bottom px-3"
    *ngrxLet="isSafetyAssessmentForm$ as isSafetyAssessmentForm"
>
    <div class="container-fluid">
        <ul class="navbar-nav navbar-expand d-none d-lg-flex flex-row">
            <li class="nav-item">
                <pace-forms-type-filter>
                    <fa-icon [icon]="faFilter"></fa-icon>
                </pace-forms-type-filter>
            </li>
            @if (supportParticipantCopies$ | async) {
                @if (!isSafetyAssessmentForm) {
                    <li class="nav-item ms-3">
                        <button
                            class="btn btn-secondary nav-item"
                            type="button"
                            (click)="openParticipantsModal()"
                            [tooltip]="'F4M_TOOLTIP_VIEW_PARTICIPANTS_COPIES_LABEL' | translate"
                            aria-label="'F4M_TOOLTIP_VIEW_PARTICIPANTS_COPIES_LABEL' | translate"
                            [delay]="500"
                            triggers="hover"
                            #tooltip="bs-tooltip"
                            [disabled]="globalReadOnly$ | async"
                        >
                            <fa-icon [icon]="faUsers"></fa-icon>
                        </button>
                    </li>
                }
                <li class="nav-item ms-3">
                    <button
                        class="btn btn-secondary nav-item"
                        type="button"
                        [tooltip]="'F4M_TOOLTIP_PREVIOUS_PARTICIPANT_COPY_LABEL' | translate"
                        aria-label="'F4M_TOOLTIP_PREVIOUS_PARTICIPANT_COPY_LABEL' | translate"
                        [delay]="500"
                        triggers="hover"
                        #tooltip="bs-tooltip"
                        (click)="selectPreviousParticipant()"
                        [disabled]="(hasParticipantCopies$ | async) === false"
                    >
                        <fa-icon [icon]="faArrowLeft"></fa-icon>
                    </button>
                </li>
                <li class="nav-item ms-1">
                    <pace-select-participant-copy></pace-select-participant-copy>
                </li>
                <li class="nav-item ms-1">
                    <button
                        class="btn btn-secondary nav-item"
                        type="button"
                        [delay]="500"
                        [tooltip]="'F4M_TOOLTIP_NEXT_PARTICIPANT_COPY_LABEL' | translate"
                        aria-label="'F4M_TOOLTIP_NEXT_PARTICIPANT_COPY_LABEL' | translate"
                        triggers="hover"
                        #tooltip="bs-tooltip"
                        (click)="selectNextParticipant()"
                        [disabled]="(hasParticipantCopies$ | async) === false"
                    >
                        <fa-icon [icon]="faArrowRight"></fa-icon>
                    </button>
                </li>
                <li class="nav-item ms-3">
                    <button
                        class="btn btn-secondary nav-item"
                        type="button"
                        [tooltip]="'F4M_TOOLTIP_DELETE_CURRENT_PARTICIPANT_LABEL' | translate"
                        aria-label="'F4M_TOOLTIP_DELETE_CURRENT_PARTICIPANT_LABEL' | translate"
                        [delay]="500"
                        triggers="hover"
                        #tooltip="bs-tooltip"
                        (click)="tooltip.hide(); deleteParticipantCopy()"
                        [disabled]="(canDelete$ | async) === false"
                    >
                        <fa-icon [icon]="faTrashAlt"></fa-icon>
                    </button>
                </li>
            }
            @if ((supportParticipantCopies$ | async) === false && (isServicePartQuestionnaire$ | async) === false) {
                @if (!hideAuthorsFormsButtons && !isSafetyAssessmentForm) {
                    <li class="nav-item ms-3">
                        <button
                            class="btn btn-secondary nav-item"
                            type="button"
                            (click)="openRecipientsModal()"
                            [tooltip]="'F4M_TOOLTIP_VIEW_AND_ENTER_RECIPIENTS_REPORT_LABEL' | translate"
                            aria-label="'F4M_TOOLTIP_VIEW_AND_ENTER_RECIPIENTS_REPORT_LABEL' | translate"
                            [delay]="500"
                            triggers="hover"
                            #tooltip="bs-tooltip"
                            [disabled]="globalReadOnly$ | async"
                        >
                            <fa-icon [icon]="faUsers"></fa-icon>
                        </button>
                    </li>
                }
                @if (displayManualIndividualizationButton$ | async) {
                    <li class="nav-item ms-3">
                        <button
                            [ngClass]="manualIndividualizationEnabled ? 'btn-primary' : 'btn-secondary'"
                            class="btn nav-item'"
                            type="button"
                            (click)="enableManualIndividualization($event)"
                            [tooltip]="'F4M_TOOLTIP_MANUAL_INDIVIDUALIZATION' | translate"
                            aria-label="'F4M_TOOLTIP_MANUAL_INDIVIDUALIZATION' | translate"
                            [delay]="500"
                            triggers="hover"
                            [disabled]="(readOnly$ | async) && !this.manualIndividualizationEnabled"
                            #tooltip="bs-tooltip"
                        >
                            <fa-icon [icon]="faSitemap"></fa-icon>
                        </button>
                    </li>
                }
            }
        </ul>
        @if (!isSafetyAssessmentForm) {
            <ul class="navbar-nav navbar-expand d-lg-none d-flex flex-row gap-3">
                @if (supportParticipantCopies$ | async) {
                    <li class="nav-item dropdown" dropdown [dropup]="true">
                        <button
                            class="btn btn-secondary btn-lg"
                            dropdownToggle
                            [attr.aria-label]="'F4M_NAVBAR_PARTICIPANTS_MENU_ARIA_LABEL' | translate"
                        >
                            <fa-icon [icon]="faEllipsisV"></fa-icon>
                        </button>
                        <ul *dropdownMenu class="d-flex flex-column gap-3 navbar-dropdown" role="menu">
                            <li role="menuitem">
                                <button
                                    class="btn btn-secondary btn-lg nav-item"
                                    type="button"
                                    (click)="openParticipantsModal()"
                                    [tooltip]="'F4M_TOOLTIP_VIEW_PARTICIPANTS_COPIES_LABEL' | translate"
                                    aria-label="'F4M_TOOLTIP_VIEW_PARTICIPANTS_COPIES_LABEL' | translate"
                                    [delay]="500"
                                    triggers="hover"
                                    #tooltip="bs-tooltip"
                                    [disabled]="globalReadOnly$ | async"
                                >
                                    <fa-icon [icon]="faUsers"></fa-icon>
                                    <span class="ms-2">Participants</span>
                                </button>
                            </li>
                            <li role="menuitem" class="d-flex flex-row gap-2">
                                <button
                                    class="btn btn-secondary btn-lg nav-item"
                                    type="button"
                                    [tooltip]="'F4M_TOOLTIP_PREVIOUS_PARTICIPANT_COPY_LABEL' | translate"
                                    aria-label="'F4M_TOOLTIP_PREVIOUS_PARTICIPANT_COPY_LABEL' | translate"
                                    [delay]="500"
                                    triggers="hover"
                                    #tooltip="bs-tooltip"
                                    (click)="selectPreviousParticipant($event)"
                                    [disabled]="(hasParticipantCopies$ | async) === false"
                                >
                                    <fa-icon [icon]="faArrowLeft"></fa-icon>
                                </button>
                                <pace-select-participant-copy></pace-select-participant-copy>
                                <button
                                    class="btn btn-secondary btn-lg nav-item"
                                    type="button"
                                    [delay]="500"
                                    [tooltip]="'F4M_TOOLTIP_NEXT_PARTICIPANT_COPY_LABEL' | translate"
                                    aria-label="'F4M_TOOLTIP_NEXT_PARTICIPANT_COPY_LABEL' | translate"
                                    triggers="hover"
                                    #tooltip="bs-tooltip"
                                    (click)="selectNextParticipant($event)"
                                    [disabled]="(hasParticipantCopies$ | async) === false"
                                >
                                    <fa-icon [icon]="faArrowRight"></fa-icon>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button
                                    class="btn btn-secondary btn-lg nav-item"
                                    type="button"
                                    [tooltip]="'F4M_TOOLTIP_DELETE_CURRENT_PARTICIPANT_LABEL' | translate"
                                    aria-label="'F4M_TOOLTIP_DELETE_CURRENT_PARTICIPANT_LABEL' | translate"
                                    [delay]="500"
                                    triggers="hover"
                                    #tooltip="bs-tooltip"
                                    (click)="tooltip.hide(); deleteParticipantCopy($event)"
                                    [disabled]="(canDelete$ | async) === false"
                                >
                                    <fa-icon [icon]="faTrashAlt"></fa-icon>
                                    <span class="ms-2">Delete copy</span>
                                </button>
                            </li>
                        </ul>
                    </li>
                }
                <ng-container>
                    <li class="nav-item dropdown" dropdown [dropup]="true">
                        <button
                            class="btn btn-secondary btn-lg"
                            dropdownToggle
                            [attr.aria-label]="'F4M_NAVBAR_INDIVIDUALIZATION_MENU_ARIA_LABEL' | translate"
                        >
                            <fa-icon [icon]="faEllipsisV"></fa-icon>
                        </button>
                        <ul
                            *dropdownMenu
                            class="d-flex flex-column gap-3 navbar-dropdown dropdown-menu-start"
                            role="menu"
                        >
                            @if (
                                (supportParticipantCopies$ | async) === false &&
                                (isServicePartQuestionnaire$ | async) === false
                            ) {
                                @if (!hideAuthorsFormsButtons) {
                                    <li role="menuitem">
                                        <button
                                            class="btn btn-secondary btn-lg nav-item"
                                            type="button"
                                            (click)="openRecipientsModal()"
                                            [tooltip]="'F4M_TOOLTIP_VIEW_AND_ENTER_RECIPIENTS_REPORT_LABEL' | translate"
                                            aria-label="'F4M_TOOLTIP_VIEW_AND_ENTER_RECIPIENTS_REPORT_LABEL' | translate"
                                            [delay]="500"
                                            triggers="hover"
                                            #tooltip="bs-tooltip"
                                            [disabled]="globalReadOnly$ | async"
                                        >
                                            <fa-icon [icon]="faUsers"></fa-icon>
                                            <span class="ms-2" [translate]="'F4M_ACTIONBAR_RECIPIENTS_LABEL'"></span>
                                        </button>
                                    </li>
                                }
                                @if (displayManualIndividualizationButton$ | async) {
                                    <li role="menuitem">
                                        <button
                                            [ngClass]="manualIndividualizationEnabled ? 'btn-primary' : 'btn-secondary'"
                                            class="btn nav-item btn-lg"
                                            type="button"
                                            (click)="enableManualIndividualization($event)"
                                            [tooltip]="'F4M_TOOLTIP_MANUAL_INDIVIDUALIZATION' | translate"
                                            aria-label="'F4M_TOOLTIP_MANUAL_INDIVIDUALIZATION' | translate"
                                            [delay]="500"
                                            triggers="hover"
                                            [disabled]="(readOnly$ | async) && !this.manualIndividualizationEnabled"
                                            #tooltip="bs-tooltip"
                                        >
                                            <fa-icon [icon]="faSitemap"></fa-icon>
                                            <span
                                                class="ms-2"
                                                [translate]="'F4M_TOOLTIP_MANUAL_INDIVIDUALIZATION'"
                                            ></span>
                                        </button>
                                    </li>
                                }
                            }
                            <li role="menuitem">
                                <pace-forms-type-filter class="nav-item"></pace-forms-type-filter>
                            </li>
                        </ul>
                    </li>
                </ng-container>
            </ul>
        }
        @if ((readOnly$ | async) === false && !isSafetyAssessmentForm) {
            @if (enableDocumentFeedbackButton$ | async) {
                <ul class="navbar-nav navbar-expand mx-auto gap-3">
                    <li class="nav-item ms-3">
                        <button
                            class="btn btn-secondary d-none d-lg-flex"
                            type="button"
                            [tooltip]="'F4M_TOOLTIP_DOCUMENT_FEEDBACK' | translate"
                            aria-label="'F4M_TOOLTIP_DOCUMENT_FEEDBACK' | translate"
                            [delay]="500"
                            triggers="hover"
                            #tooltip="bs-tooltip"
                            (click)="openDocumentFeedbackModal()"
                        >
                            <fa-icon [icon]="faFileSignature"></fa-icon>
                        </button>
                        <button
                            class="btn btn-secondary btn-lg d-lg-none d-flex"
                            type="button"
                            [tooltip]="'F4M_TOOLTIP_DOCUMENT_FEEDBACK' | translate"
                            aria-label="'F4M_TOOLTIP_DOCUMENT_FEEDBACK' | translate"
                            [delay]="500"
                            triggers="hover"
                            #tooltip="bs-tooltip"
                            (click)="openDocumentFeedbackModal()"
                        >
                            <fa-icon [icon]="faFileSignature"></fa-icon>
                        </button>
                    </li>
                </ul>
            }
        }

        <ul class="navbar-nav navbar-expand d-none d-lg-flex flex-row">
            <li class="nav-item me-3">
                <button
                    class="btn btn-secondary nav-item"
                    type="button"
                    (click)="tooltip.hide(); help()"
                    [tooltip]="'F4M_TOOLTIP_EXPLAIN_PACE_STATE_LABEL' | translate"
                    aria-label="'F4M_TOOLTIP_EXPLAIN_PACE_STATE_LABEL' | translate"
                    [delay]="500"
                    triggers="hover"
                    #tooltip="bs-tooltip"
                >
                    <fa-icon [icon]="faQuestion"></fa-icon>
                </button>
            </li>
            @if (displayNavigateToConfirmation && !hideAuthorsFormsButtons && !isSafetyAssessmentForm) {
                <li class="nav-item me-3">
                    <button
                        class="btn btn-success nav-item"
                        type="button"
                        (click)="tooltip.hide(); navigateToConfirmation()"
                        [disabled]="(canNavigateToConfirmation$ | async) === false"
                        [tooltip]="'F4M_TOOLTIP_GO_TO_APP' | translate"
                        aria-label="'F4M_TOOLTIP_GO_TO_APP' | translate"
                        [delay]="500"
                        triggers="hover"
                        #tooltip="bs-tooltip"
                    >
                        <fa-icon [icon]="faTasks"></fa-icon>
                    </button>
                </li>
            }
            <li class="nav-item me-3">
                <button
                    class="btn btn-secondary nav-item icon-btn"
                    type="button"
                    (click)="saveButtonTooltip.hide(); save()"
                    [disabled]="isSaveButtonDisabled$ | async"
                    [tooltip]="'F4M_TOOLTIP_SAVE_CURRENT_FORM_STATE' | translate"
                    aria-label="'F4M_TOOLTIP_SAVE_CURRENT_FORM_STATE' | translate"
                    triggers="hover"
                    #saveButtonTooltip="bs-tooltip"
                    *ngrxLet="isSaving$; let isSaving"
                >
                    <span class="stacker">
                        @if (!isSaving) {
                            <fa-icon [icon]="faSave"></fa-icon>
                        }
                        @if (isSaving) {
                            <fa-icon [icon]="faCog" [spin]="isSaving"></fa-icon>
                        }
                    </span>
                </button>
            </li>
            @if (!hideAuthorsFormsButtons && !isSafetyAssessmentForm) {
                <li class="nav-item me-3">
                    <button
                        class="btn btn-warning nav-item"
                        type="button"
                        (click)="tooltip.hide(); abort()"
                        [disabled]="(canAbort$ | async) === false"
                        [tooltip]="'F4M_TOOLTIP_ABORT_CURRENTLY_VIEWED_FORM' | translate"
                        aria-label="'F4M_TOOLTIP_ABORT_CURRENTLY_VIEWED_FORM' | translate"
                        [delay]="500"
                        triggers="hover"
                        #tooltip="bs-tooltip"
                    >
                        <fa-icon [icon]="faMinusCircle"></fa-icon>
                    </button>
                </li>
            }
            @if (!hideAuthorsFormsButtons) {
                <li class="nav-item me-3">
                    <button
                        class="btn btn-secondary nav-item"
                        type="button"
                        (click)="tooltip.hide(); refresh()"
                        [disabled]="(canReload$ | async) === false"
                        [tooltip]="'F4M_TOOLTIP_RELOAD_THE_CURRENT_FORM' | translate"
                        aria-label="'F4M_TOOLTIP_RELOAD_THE_CURRENT_FORM' | translate"
                        [delay]="500"
                        triggers="hover"
                        #tooltip="bs-tooltip"
                    >
                        <fa-icon [icon]="faRedo"></fa-icon>
                    </button>
                </li>
            }
            @if (!hideAuthorsFormsButtons && !isSafetyAssessmentForm) {
                <li class="nav-item me-3">
                    <button
                        class="btn btn-secondary nav-item"
                        type="button"
                        (click)="tooltip.hide(); handOver()"
                        [disabled]="(canHandOver$ | async) === false"
                        [tooltip]="'F4M_TOOLTIP_HANDOVER_THE_FORM' | translate"
                        aria-label="'F4M_TOOLTIP_HANDOVER_THE_FORM' | translate"
                        [delay]="500"
                        triggers="hover"
                        #tooltip="bs-tooltip"
                    >
                        <fa-icon [icon]="faUserFriends"></fa-icon>
                    </button>
                </li>
            }
            @if (!hideSubmitButtonforForms) {
                <li class="nav-item">
                    <button
                        class="btn btn-primary nav-item"
                        type="button"
                        (click)="tooltip.hide(); submit()"
                        [disabled]="(canSubmit$ | async) === false"
                        [hidden]="hideSubmitButtonForParticipant$ | async"
                        [delay]="500"
                        triggers="hover"
                        [tooltip]="'F4M_TOOLTIP_SUBMIT_THE_FORM' | translate"
                        aria-label="'F4M_TOOLTIP_SUBMIT_THE_FORM' | translate"
                        #tooltip="bs-tooltip"
                        translate="F4M_NAVBAR_SUBMIT_BUTTON_LABEL"
                    >
                        <span class="ms-2"><fa-icon [icon]="faFileUpload"></fa-icon></span>
                    </button>
                </li>
            }
        </ul>
        <ul class="nav navbar-nav d-lg-none d-flex flex-row gap-3 ms-auto">
            @if (!hideSubmitButtonforForms) {
                <li class="nav-item">
                    <button
                        class="btn btn-primary btn-lg"
                        type="button"
                        (click)="tooltip.hide(); submit()"
                        [disabled]="(canSubmit$ | async) === false"
                        [hidden]="hideSubmitButtonForParticipant$ | async"
                        [delay]="500"
                        triggers="hover"
                        [tooltip]="'F4M_TOOLTIP_SUBMIT_THE_FORM' | translate"
                        aria-label="'F4M_TOOLTIP_SUBMIT_THE_FORM' | translate"
                        #tooltip="bs-tooltip"
                        translate="F4M_NAVBAR_SUBMIT_BUTTON_LABEL"
                    >
                        <span class="ms-2"><fa-icon [icon]="faFileUpload"></fa-icon></span>
                    </button>
                </li>
            }
            <li class="nav-item dropdown" dropdown [dropup]="true">
                <button
                    class="btn btn-secondary btn-lg"
                    dropdownToggle
                    [attr.aria-label]="'F4M_NAVBAR_FORMS_MENU_ARIA_LABEL' | translate"
                >
                    <fa-icon [icon]="faEllipsisV"></fa-icon>
                </button>
                <ul *dropdownMenu class="d-flex flex-column gap-3 navbar-dropdown dropdown-menu-end" role="menu">
                    <li role="menuitem">
                        <button
                            class="btn btn-secondary btn-lg"
                            type="button"
                            (click)="tooltip.hide(); help()"
                            [tooltip]="'F4M_TOOLTIP_EXPLAIN_PACE_STATE_LABEL' | translate"
                            aria-label="'F4M_TOOLTIP_EXPLAIN_PACE_STATE_LABEL' | translate"
                            [delay]="500"
                            triggers="hover"
                            #tooltip="bs-tooltip"
                        >
                            <fa-icon [icon]="faQuestion"></fa-icon>
                            <span class="ms-2" [translate]="'F4M_ACTIONBAR_MODE_LABEL'"></span>
                        </button>
                    </li>
                    @if (displayNavigateToConfirmation && !hideAuthorsFormsButtons && !isSafetyAssessmentForm) {
                        <li role="menuitem">
                            <button
                                class="btn btn-success btn-lg"
                                type="button"
                                (click)="tooltip.hide(); navigateToConfirmation()"
                                [disabled]="(canNavigateToConfirmation$ | async) === false"
                                [tooltip]="'F4M_TOOLTIP_GO_TO_APP' | translate"
                                aria-label="'F4M_TOOLTIP_GO_TO_APP' | translate"
                                [delay]="500"
                                triggers="hover"
                                #tooltip="bs-tooltip"
                            >
                                <fa-icon [icon]="faTasks"></fa-icon>
                                <span class="ms-2" [translate]="'F4M_ACTIONBAR_TO_APP_LABEL'"></span>
                            </button>
                        </li>
                    }
                    <li role="menuitem">
                        <button
                            class="btn btn-secondary btn-lg icon-btn"
                            type="button"
                            (click)="saveButtonTooltip.hide(); save($event)"
                            [disabled]="isSaveButtonDisabled$ | async"
                            [tooltip]="'F4M_TOOLTIP_SAVE_CURRENT_FORM_STATE' | translate"
                            aria-label="'F4M_TOOLTIP_SAVE_CURRENT_FORM_STATE' | translate"
                            triggers="hover"
                            #saveButtonTooltip="bs-tooltip"
                            *ngrxLet="isSaving$; let isSaving"
                        >
                            <span class="stacker">
                                @if (!isSaving) {
                                    <fa-icon [icon]="faSave"></fa-icon>
                                }
                                @if (!isSaving) {
                                    <span class="ms-2" [translate]="'F4M_ACTIONBAR_SAVE_LABEL'"></span>
                                }
                                @if (isSaving) {
                                    <fa-icon [icon]="faCog" [spin]="isSaving"></fa-icon>
                                }
                                @if (isSaving) {
                                    <span class="ms-2" [translate]="'F4M_ACTIONBAR_SAVING_LABEL'"></span>
                                }
                            </span>
                        </button>
                    </li>
                    @if (!hideAuthorsFormsButtons && !isSafetyAssessmentForm) {
                        <li role="menuitem">
                            <button
                                class="btn btn-warning btn-lg"
                                type="button"
                                (click)="tooltip.hide(); abort()"
                                [disabled]="(canAbort$ | async) === false"
                                [tooltip]="'F4M_TOOLTIP_ABORT_CURRENTLY_VIEWED_FORM' | translate"
                                aria-label="'F4M_TOOLTIP_ABORT_CURRENTLY_VIEWED_FORM' | translate"
                                [delay]="500"
                                triggers="hover"
                                #tooltip="bs-tooltip"
                            >
                                <fa-icon [icon]="faMinusCircle"></fa-icon>
                                <span class="ms-2" [translate]="'F4M_ACTIONBAR_ABORT_LABEL'"></span>
                            </button>
                        </li>
                    }
                    @if (!hideAuthorsFormsButtons && !isSafetyAssessmentForm) {
                        <li role="menuitem">
                            <button
                                class="btn btn-secondary btn-lg"
                                type="button"
                                (click)="tooltip.hide(); refresh()"
                                [disabled]="(canReload$ | async) === false"
                                [tooltip]="'F4M_TOOLTIP_RELOAD_THE_CURRENT_FORM' | translate"
                                aria-label="'F4M_TOOLTIP_RELOAD_THE_CURRENT_FORM' | translate"
                                [delay]="500"
                                triggers="hover"
                                #tooltip="bs-tooltip"
                            >
                                <fa-icon [icon]="faRedo"></fa-icon>
                                <span class="ms-2" [translate]="'F4M_ACTIONBAR_REFRESH_LABEL'"></span>
                            </button>
                        </li>
                    }
                    @if (!hideAuthorsFormsButtons) {
                        <li role="menuitem">
                            <button
                                class="btn btn-secondary btn-lg"
                                type="button"
                                (click)="tooltip.hide(); handOver()"
                                [disabled]="(canHandOver$ | async) === false"
                                [tooltip]="'F4M_TOOLTIP_HANDOVER_THE_FORM' | translate"
                                aria-label="'F4M_TOOLTIP_HANDOVER_THE_FORM' | translate"
                                [delay]="500"
                                triggers="hover"
                                #tooltip="bs-tooltip"
                            >
                                <fa-icon [icon]="faUserFriends"></fa-icon>
                                <span class="ms-2" [translate]="'F4M_ACTIONBAR_HANDOVER_LABEL'"></span>
                            </button>
                        </li>
                    }
                </ul>
            </li>
        </ul>
    </div>
</nav>
